import { inject, Injectable } from '@angular/core';
import { ApiRouteInspectionMeasureService } from 'src/app/api/elite/routes/inspection-measure.service';
import { forkJoin, Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import {
  InspectionMeasureTool,
  InspectionMeasureType,
} from 'src/app/api/elite/types/inspection-assembly-item';
import { RoutingService } from 'src/app/core/services/routing.service';
import { ApiRouteSpecialLabelService } from '../../../api/elite/routes/special-label.service';
import { ApiRouteInspectionTestsService } from '../../../api/elite/routes/inspection-tests.service';
import { ApiRouteInspectionAqlService } from '../../../api/elite/routes/inspection-aql.service';
import { ApiRouteCertificateService } from '../../../api/elite/routes/certificate.service';
import { Certificate } from '../../../api/elite/types/certificate';
import { SpecialLabel } from '../../../api/elite/types/special-label';

@Injectable({
  providedIn: 'root',
})
export class QualityControlInspectionDataFormApiService {
  private readonly apiInspectionMeasureRouter = inject(
    ApiRouteInspectionMeasureService
  );
  private readonly inspectionTestsService = inject(
    ApiRouteInspectionTestsService
  );
  private readonly inspectionAqlRouter = inject(ApiRouteInspectionAqlService);
  private readonly apiRouteSpecialLabelRouter = inject(
    ApiRouteSpecialLabelService
  );
  private readonly certificateRouter = inject(ApiRouteCertificateService);

  private readonly routerService = inject(RoutingService);

  constructor() {}

  data(): Observable<{
    measureTypes: InspectionMeasureType[];
    testTypes: InspectionMeasureTool[];
    aqlTypes: { id: number; name: string }[];
    specialLabels: SpecialLabel[];
    certificates: Certificate[];
  }> {
    return forkJoin({
      measureTypes: this.getMeasureTypes(),
      testTypes: this.inspectionTestsService.allTypes(),
      aqlTypes: this.inspectionAqlRouter.all(),
      specialLabels: this.apiRouteSpecialLabelRouter.getAll(),
      certificates: this.certificateRouter.getCertificates(),
    });
  }

  private getMeasureTypes(): Observable<InspectionMeasureType[]> {
    return this.routerService.lastRouteData<string>('department').pipe(
      take(1),
      switchMap((department) =>
        this.apiInspectionMeasureRouter.typesOfMeasure(department)
      )
    );
  }
}
